export default "__VITE_ASSET__QEoYUGEM__"